import styled from "styled-components"

export const ButtonStyles = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 0.7rem;
  align-self: flex-start;
  border: 1px solid var(--color-gold-500);
  border-radius: 9999px;
  padding: 0.85rem 1.6rem;
  background-color: var(--color-gold-500);
  color: #1a1206;
  font-family: var(--font-sans);
  font-size: 0.95rem;
  font-weight: 600;
  letter-spacing: 0.01em;
  text-decoration: none;
  cursor: pointer;
  transition: background-color 0.4s var(--ease-power),
    border-color 0.4s var(--ease-power), color 0.4s var(--ease-power),
    box-shadow 0.4s var(--ease-power);

  &.btn--arrow {
    padding: 0.55rem 0.6rem 0.55rem 1.5rem;
  }

  .btn__arrow {
    display: inline-grid;
    place-items: center;
    width: 1.85rem;
    height: 1.85rem;
    border-radius: 50%;
    background: #1a1206;
    color: var(--color-gold-500);
    font-size: 0.95rem;
    transition: transform 0.45s var(--ease-power), background 0.4s;
  }

  &:hover,
  &:focus {
    background-color: var(--color-gold-400);
    border-color: var(--color-gold-400);
    color: #1a1206;
    box-shadow: 0 12px 34px -10px var(--color-glow);

    .btn__arrow {
      transform: translate(3px, -3px);
    }
  }

  /* secondary / ghost */
  &.btn--ghost {
    background-color: transparent;
    color: var(--color-paper);
    border-color: rgba(246, 243, 234, 0.22);

    .btn__arrow {
      background: rgba(231, 163, 56, 0.14);
      color: var(--color-gold-500);
    }

    &:hover,
    &:focus {
      background-color: transparent;
      border-color: var(--color-gold-500);
      color: var(--color-gold-500);
      box-shadow: none;

      .btn__arrow {
        background: rgba(231, 163, 56, 0.2);
      }
    }
  }
`
